import { z } from "zod";
import { schedulingAvailabilityWindowSchema, schedulingBookingInputSchema, schedulingBookingStateSchema, schedulingInstantSchema, schedulingPublishInputSchema, } from "./scheduling.js";
export const schedulingCapabilitySchema = z.string().regex(/^[A-Za-z0-9_-]{43}$/u);
export const schedulingIdempotencyKeySchema = z.string().regex(/^[A-Za-z0-9_-]{16,128}$/u);
export const schedulingPublishRequestSchema = z.object({
    specification: schedulingPublishInputSchema, idempotencyKey: schedulingIdempotencyKeySchema,
}).strict();
export const schedulingPublishResponseSchema = z.object({
    proposalId: z.uuid(), revision: z.number().int().positive(), token: schedulingCapabilitySchema,
}).strict();
/** Public gateway supplies the absolute guest URL from its configured origin and verified tenant. */
export const schedulingPublishedLinkSchema = schedulingPublishResponseSchema.extend({ bookingUrl: z.url() }).strict();
export const schedulingPublicProposalRequestSchema = z.object({ token: schedulingCapabilitySchema }).strict();
export const schedulingPublicAvailabilityRequestSchema = z.object({
    token: schedulingCapabilitySchema, window: schedulingAvailabilityWindowSchema,
}).strict();
export const schedulingPublicClaimRequestSchema = z.object({
    token: schedulingCapabilitySchema, booking: schedulingBookingInputSchema, idempotencyKey: schedulingIdempotencyKeySchema,
}).strict();
export const schedulingPublicReceiptSchema = z.object({
    status: schedulingBookingStateSchema, start: schedulingInstantSchema, end: schedulingInstantSchema,
}).strict();
export const schedulingPublicClaimResponseSchema = schedulingPublicReceiptSchema.extend({ receiptToken: schedulingCapabilitySchema });
export const schedulingRevokeRequestSchema = z.object({ proposalId: z.uuid() }).strict();
export const schedulingCancelRequestSchema = z.object({ bookingId: z.uuid() }).strict();
